(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[989],{

/***/ 325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[page]",
      function () {
        return __webpack_require__(2573);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _page_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./lib/seo-context.js
var seo_context = __webpack_require__(4449);
// EXTERNAL MODULE: ./components/layout.jsx + 5 modules
var layout = __webpack_require__(5726);
// EXTERNAL MODULE: ./components/hero-subpage.jsx
var hero_subpage = __webpack_require__(5467);
// EXTERNAL MODULE: ./lib/helper.js
var helper = __webpack_require__(4994);
// EXTERNAL MODULE: ./lib/global-context.js
var global_context = __webpack_require__(5439);
// EXTERNAL MODULE: ./components/blog-articles-list.jsx
var blog_articles_list = __webpack_require__(1791);
// EXTERNAL MODULE: ./components/pagination.jsx
var pagination = __webpack_require__(7809);
// EXTERNAL MODULE: ./components/blog-category-list.jsx
var blog_category_list = __webpack_require__(2508);
// EXTERNAL MODULE: ./components/rss-feed.jsx
var rss_feed = __webpack_require__(7337);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/write-for-us.jsx



function WriteForUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col border-t border-gray-100 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: "!text-maturity-500 font-semibold leading-tight",
                children: [
                    "Join Our Writing Team:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Contribute to Our Blog"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-left",
                children: [
                    "Are you passionate about writing and eager to share your insights and expertise with a wide audience? Then we'd love to hear from you! Our blog covers a variety of topics and we're always on the lookout for fresh perspectives and new voices. Whether you're a seasoned blogger or just starting out, we welcome contributions from writers of all levels. If you're interested in being a part of a dynamic and growing community, ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "mailto:webmaster@arkarobot.com",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-trust underline",
                            children: "submit your proposal today!"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var write_for_us = (WriteForUs);

;// CONCATENATED MODULE: ./pages/blog/[page].jsx












var Page = function(props) {
    var state = (0,global_context/* useGlobalContext */.bN)().state;
    var global = state;
    var pageProps = props.pageProps;
    if (!pageProps) {
        return "";
    }
    var seo = pageProps && pageProps.seo ? (0,helper/* Merge */.$U)(global.seo, pageProps.seo) : global.seo;
    seo.canonicalURL = "".concat("https://www.arka-parcel-lockers.com", "/blog/").concat(pageProps.page);
    seo.metaTitle += " - Page ".concat(pageProps.page);
    seo.metaDescription += " - Page ".concat(pageProps.page);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(seo_context/* default.Provider */.Z.Provider, {
        value: seo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
            footerClass: "skew-maturity-100",
            languageData: {
                originalSlug: "blog",
                languages: pageProps.localizations
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_subpage/* default */.Z, (0,_object_spread/* default */.Z)({
                    full: true
                }, pageProps.hero), "hero-subpage"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "container mx-auto content",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row p-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col w-full lg:w-2/3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "articles",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_articles_list/* default */.Z, (0,_object_spread/* default */.Z)({}, pageProps.articles))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex mt-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                                            url: "/blog",
                                            pagination: pageProps.articles.meta.pagination
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col w-full lg:w-1/3 lg:pl-10 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "sticky top-32 w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_category_list/* default */.Z, {
                                            selected: "",
                                            categories: pageProps.categories
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rss_feed/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(write_for_us, {})
                                    ]
                                })
                            })
                        ]
                    })
                }, "blog-articles")
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var _page_ = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [396,818,726,413,774,888,179], function() { return __webpack_exec__(325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);